<template>
  <div>
  <el-dialog
    title=""
    :visible.sync="$store.state.warning.warningFalg"
    width="60%"
    :append-to-body="true"
    center>
      <p class="wrap" v-html="$store.state.warning.warningMsg"></p>

      <span slot="footer" class="dialog-footer">
        <slot @click.stop="cancel"></slot>
      </span>
  </el-dialog>
  </div>
</template>
<script>
export default {
  name: "warningDlgController",
  data() {
    return {
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    }
  },
  mounted: function() {
    var that = this;
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.title) {
        that.$store.commit("setPageTitle", to.meta.title)
        document.title = 'Zeelo cms | '+that.$store.state.pageTitle
      }
      if(that.$store.state.edit&&to.path!='/'){
        that.$store.commit("setwarning", {
          string: that.$i18n.t("message.leaveTip"),
          boolean: true,
          button: [{
              name:'Stay',
              callBack:function(){
                that.$store.commit("setwarning", { string: "", boolean: false });
              }
            }, {
              name:'Leave',
              callBack:function(){
                
                that.$store.commit("setwarning", { string: "", boolean: false });
                next();
              }
            }]
        });
      }else{
        next();
      }
    })
    this.$router.afterEach((to, from, next) => {
      $('.spiner-postion').addClass('hide');
      that.$store.state.edit = false;
    })
  }
};
</script>
